import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=a8e07c2c"
var script = {}
import style0 from "./HomeView.vue?vue&type=style&index=0&id=a8e07c2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports